import { defineStore } from "pinia";
import type { Artwork } from "~~/types/artwork";
import { useMessage } from "./app-toast";

interface FavoriteStoreState {
    loading: boolean;
    fetching: boolean;
    favorites: Artwork[];
    favoriteIds: string[];
    currentId: string | null;
}

export const useFavoriteStore = defineStore("FavoriteStore", {
    state: (): FavoriteStoreState => ({
        loading: false,
        fetching: false,
        favorites: [],
        favoriteIds: [],
        currentId: null,
    }),
    actions: {
        async toggleFavorite(artworkId: string): Promise<void> {
            const { $api } = useNuxtApp()
            this.currentId = artworkId;
            const toast = useMessage();
            try {
                this.loading = true;

                await $api(`/favorite/toggle`, {
                    method: 'POST',
                    body: { artworkId }
                });
                if (this.favoriteIds.includes(artworkId)) {
                    this.favoriteIds = this.favoriteIds.filter((id) => id !== artworkId);
                    this.favorites = this.favorites.filter(
                        (art) => art._id !== artworkId,
                    );
                } else {
                    this.favoriteIds.push(artworkId);
                }
            } catch (e) {
                toast.error(e)
            } finally {
                this.loading = false;
                this.currentId = null;
            }
        },
        async getFavorites(): Promise<void> {
            const { $api } = useNuxtApp()

            try {
                this.fetching = true;
                const response = await $api<any>(`/favorite/my-favorites`);
                const f = response.data;
                this.favorites = f;
                this.favoriteIds = f.map((item: Artwork) => item._id);
            } catch (_e) {
            } finally {
                this.fetching = false;
            }
        },
    },
});
